import Moment from 'react-moment';


const TableCellTime = (props: any) => {
  let dataStart = props.dataStart ?? false;
  let dataEnd = props.dataEnd ?? false;

  return (
    <td>
      {((dataStart) ? <span className="StartDate"><b><Moment format="HH:mm">{dataStart}</Moment></b></span> : <></>)}
      {((dataEnd) ? <span className="EndDate"><b><Moment format="HH:mm">{dataEnd}</Moment></b></span> : <></>)}
    </td>
  )
}

export default TableCellTime